import * as React from 'react'
import {indexedMap} from '../../Data/ArrayHelper'
import {
    ProductCalculationImportFormular,
    ProductCalculationPriceRow
} from './ProductCalculationImportState'
import {ProductCalculationImportAction} from './ProductCalculationImportActions'
import {errorMessage} from '../../Data/FormValidation'
import {
    Card,
    TextField,
    TableHeader,
    Table,
    TableRow,
    TableHeaderColumn,
    TableBody,
    TableRowColumn
} from 'material-ui'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import Add from 'material-ui/svg-icons/content/add'
import {ProductCalculationImportAutoSuggestionSelect} from './AutoSuggestions/ProductCalculationAutoSuggestionSelect'
import FlatButton from 'material-ui/FlatButton'
import IconButton from 'material-ui/IconButton'
import Delete from 'material-ui/svg-icons/action/delete'

export function ProductCalclationImportFormularView({form, dispatch}: {
    form: ProductCalculationImportFormular
    dispatch: (action: ProductCalculationImportAction) => void,
}) {
    return (
        <div>
            <div className="row">
                <div className="column">
                    <Card
                        className="tab__form-card"
                    >
                        {checkIfMessagesMissing(form) &&
                        <div style={{float: 'right'}}>
                            <FlatButton
                                label="Fehlende Einträge anlegen"
                                secondary={true}
                                onClick={() => dispatch({
                                    type: 'OpenMessageModal'
                                })}
                            />
                        </div>
                        }
                        <h4>Produktkalkulationsattribute</h4>

                        <ProductCalculationImportAutoSuggestionSelect
                            dispatch={dispatch}
                            keyType={'type'}
                            label={'Typ'}
                            stateSearchValue={form.type.input}
                            stateSuggestions={form.type.suggestions}
                            stateIdValue={form.type.value}
                            forceChecked={form.type.wasRecentlyCreated}
                            submissionAttempted={form.submissionAttempted}
                        />
                        <ProductCalculationImportAutoSuggestionSelect
                            dispatch={dispatch}
                            keyType={'format'}
                            label={'Format'}
                            stateSearchValue={form.format.input}
                            stateSuggestions={form.format.suggestions}
                            stateIdValue={form.format.value}
                            forceChecked={form.format.wasRecentlyCreated}
                            submissionAttempted={form.submissionAttempted}
                        />
                        <ProductCalculationImportAutoSuggestionSelect
                            dispatch={dispatch}
                            keyType={'coverage'}
                            label={'Umfang'}
                            stateSearchValue={form.coverage.input}
                            stateSuggestions={form.coverage.suggestions}
                            stateIdValue={form.coverage.value}
                            forceChecked={form.coverage.wasRecentlyCreated}
                            submissionAttempted={form.submissionAttempted}
                        />
                        <ProductCalculationImportAutoSuggestionSelect
                            dispatch={dispatch}
                            keyType={'print'}
                            label={'Druck'}
                            stateSearchValue={form.print.input}
                            stateSuggestions={form.print.suggestions}
                            stateIdValue={form.print.value}
                            forceChecked={form.print.wasRecentlyCreated}
                            submissionAttempted={form.submissionAttempted}
                        />
                        <ProductCalculationImportAutoSuggestionSelect
                            dispatch={dispatch}
                            keyType={'paper'}
                            label={'Papier'}
                            stateSearchValue={form.paper.input}
                            stateSuggestions={form.paper.suggestions}
                            stateIdValue={form.paper.value}
                            forceChecked={form.paper.wasRecentlyCreated}
                            submissionAttempted={form.submissionAttempted}
                        />
                        <ProductCalculationImportAutoSuggestionSelect
                            dispatch={dispatch}
                            keyType={'processing'}
                            label={'Verarbeitung'}
                            stateSearchValue={form.processing.input}
                            stateSuggestions={form.processing.suggestions}
                            stateIdValue={form.processing.value}
                            forceChecked={form.processing.wasRecentlyCreated}
                            submissionAttempted={form.submissionAttempted}
                        />

                        <TextField
                            floatingLabelText="Gewicht (g)"
                            type="text"
                            value={
                                form.weight
                            }
                            underlineDisabledStyle={{display: 'none'}}
                            inputStyle={{color: 'black'}}
                            floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                            floatingLabelShrinkStyle={{color: 'black'}}
                            fullWidth={true}
                            errorText={errorMessage(form.weightValidation)}
                            onChange={(event, value) => {
                                dispatch({
                                    type: 'ChangeKeyedInputField',
                                    key: 'weight',
                                    value
                                })
                            }}
                        />
                    </Card>
                </div>
                <div className="column">
                    <Card
                        className="tab__form-card"
                    >
                        <div style={{float: 'right'}}>
                            <FloatingActionButton
                                mini={true}
                                onClick={() => dispatch({
                                    type: 'AddPriceDefinitionRow'
                                })}
                            >
                                <Add/>
                            </FloatingActionButton>
                        </div>

                        <h4>Preisliste</h4>

                        <Table>
                            <TableHeader
                                displaySelectAll={false}
                                adjustForCheckbox={false}
                            >
                                <TableRow>
                                    <TableHeaderColumn style={{width: '85px'}}>
                                        Auflage
                                    </TableHeaderColumn>
                                    <TableHeaderColumn style={{textAlign: 'right'}}>
                                        Preis pro Stück
                                    </TableHeaderColumn>
                                    <TableHeaderColumn style={{textAlign: 'center'}}>
                                        Optionen
                                    </TableHeaderColumn>
                                </TableRow>
                            </TableHeader>
                            <TableBody
                                displayRowCheckbox={false}
                            >
                                {form.priceList.length > 0 &&
                                indexedMap(
                                    (index: number, pDR: ProductCalculationPriceRow) =>
                                        PriceDefinitionRow(pDR, index, dispatch),
                                    form.priceList
                                )}
                            </TableBody>
                        </Table>
                    </Card>
                </div>
            </div>
        </div>
    )
}

function PriceDefinitionRow(priceDefinitionRow: ProductCalculationPriceRow,
                            index: number,
                            dispatch: (action: ProductCalculationImportAction) => void) {
    return (
        <TableRow key={index} selectable={false}>
            <TableRowColumn style={{width: '85px'}}>
                {index === 0 ?
                    priceDefinitionRow.minQuantity :
                    <TextField
                        type="text"
                        value={priceDefinitionRow.minQuantity}
                        id={index + '-minquantity'}
                        name={index + '-minquantity'}
                        onChange={(event, value) => dispatch({
                            type: 'MinQuantityChanged',
                            index: index,
                            value: value
                        })}
                        errorText={errorMessage(priceDefinitionRow.minQuantityValidation)}
                    />
                }
            </TableRowColumn>
            <TableRowColumn style={{textAlign: 'right'}}>
                <div style={{width: 'calc(100% - 16px)', float: 'left'}}>
                    <TextField
                        type="text"
                        value={priceDefinitionRow.price}
                        fullWidth={true}
                        inputStyle={{textAlign: 'right'}}
                        id={index + '-price'}
                        name={index + '-price'}
                        onChange={(event, value) => dispatch({
                            type: 'PriceChanged',
                            index: index,
                            value: value
                        })}
                        errorText={errorMessage(priceDefinitionRow.priceValidation)}
                    />
                </div>
                <div
                    style={{
                        width: '16px',
                        float: 'right',
                        paddingTop: '16px',
                        paddingBottom: '16px',
                        fontSize: '1.2em'
                    }}
                >
                    &euro;
                </div>
            </TableRowColumn>
            <TableRowColumn style={{textAlign: 'center'}}>
                {index !== 0 &&
                <IconButton
                    touch={true}
                    onTouchTap={() => dispatch({
                        type: 'RemovePriceDefinitionRow',
                        index: index
                    })}
                >
                    <Delete/>
                </IconButton>
                }
            </TableRowColumn>
        </TableRow>
    )
}

function checkIfMessagesMissing(form: ProductCalculationImportFormular): boolean {
    return (
        form.type.input === '' || form.type.value === 0
        || form.format.input === '' || form.format.value === 0
        || form.coverage.input === '' || form.coverage.value === 0
        || form.print.input === '' || form.print.value === 0
        || form.paper.input === '' || form.paper.value === 0
        || form.processing.input === '' || form.processing.value === 0
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ProductCalculationImport/ProductCalculationImportFormularView.tsx